<ion-content>
  <!-- MODAL CLOSE -->
  <ion-button fill="clear" class="search-close ion-float-right" (click)="dismissModal()">
    <ion-icon slot="icon-only" name="close"></ion-icon>
  </ion-button>

  <!-- HEADING -->
  <h2 class="search-heading">Search</h2>

  <!-- TYPEAHEAD SSEARCH -->
  <app-typeahead [inputValue]="searchObject?.term" (userSelectedResult)="selectSuggestion($event)"></app-typeahead>

  <!-- RESULTS -->
  <ng-container *ngIf="searchResults && searchResults.length > 0; else noResults">
    <ion-grid class="ion-no-padding ion-no-margin">
      <ion-row>
        <ion-col size="12">
          <ion-text>
            <p class="search-message">
              {{ totalResults }} Stores for "{{ searchObject?.originalText }}"
              in
              <strong [innerHTML]="searchContext"></strong>
            </p>
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="search-results">
      <ion-row>
        <ion-col size="12" size-sm="4" size-lg="3" *ngFor="let item of searchResults">
          <ion-card (click)="linkToDetail(item)" class="card-boxed">
            <div *ngIf="item.logoImage" class="card-img">
              <app-img-format [src]="item.logoImage" [alt]="item.title" [aspectRatio]="'16:9'"
                [disableLazyLoad]="true"></app-img-format>
            </div>
            <ion-card-header>
              <ion-card-subtitle>
                <ng-container *ngIf="
                    item.typeGeneral.new &&
                    item.currentStatus.toLowerCase().includes('open')
                  ">
                  New Store |
                </ng-container>
                <ng-container *ngIf="
                    item.typeGeneral.popup &&
                    item.currentStatus.toLowerCase().includes('open')
                  ">
                  Pop-Up |
                </ng-container>
                {{ item.currentStatus }}
                <ng-container *ngIf="item.currentStatus.toLowerCase().includes('open')">
                  | {{ storeOpenClose(item) }}
                </ng-container>
              </ion-card-subtitle>
              <ion-card-title>{{ item.title }}</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              {{ item.typeGeneral.telephone_number }} |
              {{ item.typeGeneral.level }}
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- LOAD MORE -->
    <div class="ion-margin-top ion-flex ion-justify-content-center">

      <app-button *ngIf="hasMoreItems" type="secondary" (click)="loadMore()" [disabled]="xhrInProgress"
        [icon]="{ name: 'arrow-right', position: 'right' }">
        <ng-container *ngIf="xhrInProgress; else loadMsg">
          Loading
        </ng-container>
        <ng-template #loadMsg>
          Load more
        </ng-template>
      </app-button>
    </div>
  </ng-container>

  <!-- NO RESULTS FALLBACK -->
  <ng-template #noResults>
    <ng-container *ngIf="!xhrInProgress; else loadingResults">
      <ion-grid class="ion-no-padding ion-no-margin" *ngIf="searchObject?.originalText">
        <ion-row>
          <ion-col size="12">
            <ion-text>
              <p class="search-no-results">
                We couldn't find any store matching the phrase "{{
                searchObject?.originalText
                }}". Please check your spelling or try a more generic search
                term or select an option below.
              </p>
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- POPULAR SEARCHES -->
      <section class="filled" *ngIf="environment.environment_name != 'woodlands'">
        <h3>Popular Searches</h3>
        <p *ngFor="let item of popularSearches; let i = index" class="ion-no-margin" [innerHTML]="item"></p>
      </section>

      <!-- CATEGORY FILTERS -->
      <section *ngIf="
          !filtersFetched ||
          (filtersFetched && categories && categories.length > 0)
        ">
        <h3>Category Filter</h3>
        <ion-button color="secondary" fill="clear" *ngIf="!filtersFetched; else categoryOptions">
          Loading Categories
          <ion-spinner slot="end" name="crescent"></ion-spinner>
        </ion-button>
        <ng-template #categoryOptions>
          <a *ngFor="let cat of categories | slice : 0 : amountCategories" class="tag" (click)="searchByCategory(cat)">
            {{ cat.title }}
          </a>
          <a *ngIf="categories.length > amountCategories" class="tag" (click)="showMoreCategories()">
            <ion-icon slot="icon-only" name="add-outline"></ion-icon>
          </a>
        </ng-template>
      </section>

      <!-- SPECIALITY FILTERS -->
      <section *ngIf="
          !filtersFetched ||
          (filtersFetched && specialities && specialities.length > 0)
        ">
        <h3>Speciality Stores</h3>
        <ion-button color="secondary" fill="clear" *ngIf="!specialities; else specialityOptions">
          Loading Speciality Stores
          <ion-spinner slot="end" name="crescent"></ion-spinner>
        </ion-button>
        <ng-template #specialityOptions>
          <a *ngFor="let occasion of specialities" (click)="searchByOccasion(occasion)" class="tag">
            {{ occasion }}
          </a>
        </ng-template>
      </section>
    </ng-container>
  </ng-template>

  <!-- SKELETON LOADER -->
  <ng-template #loadingResults>
    <ion-grid class="search-results">
      <ion-row>
        <ion-col size="12" size-sm="4" size-md="3" *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8]">
          <ion-card class="card-boxed">
            <div class="card-img">
              <ion-skeleton-text animated style="padding-top: 56.25%"></ion-skeleton-text>
            </div>
            <ion-card-header>
              <ion-card-subtitle><ion-skeleton-text animated style="width: 70%"></ion-skeleton-text></ion-card-subtitle>
              <ion-card-title><ion-skeleton-text animated style="width: 50%"></ion-skeleton-text></ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>
</ion-content>